var modalStyleObject = {
  "modal": {
    "position": "fixed",
    "top": "0",
    "right": "0",
    "bottom": "0",
    "left": "0",
    "zIndex": "201",
    "overflow": "hidden",
    "outline": "0"
  },
  "modal_div_role_dialog": {
    "&:focus": {
      "outline": "dashed 1px rgba(255, 255, 255, 0.92)",
      "outlineOffset": "3px"
    }
  },
  "modalScreen": {
    "position": "fixed",
    "width": "100%",
    "height": "100%",
    "backgroundColor": "rgba(0, 0, 0, 0.4)",
    "top": "0",
    "left": "0",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "flexDirection": "column"
  },
  "modal_header": {
    "padding": "0.9375rem 1.25rem"
  }
};

export default modalStyleObject;
